export default __webpack_public_path__ + "static/media/logo.521c0505.png";